"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createWalletClient = void 0;
const parseAccount_js_1 = require("../accounts/utils/parseAccount.js");
const createClient_js_1 = require("./createClient.js");
const wallet_js_1 = require("./decorators/wallet.js");
function createWalletClient({ account, chain, transport, key = 'wallet', name = 'Wallet Client', pollingInterval, }) {
    const client = {
        ...(0, createClient_js_1.createClient)({
            chain,
            key,
            name,
            pollingInterval,
            transport: (opts) => transport({ ...opts, retryCount: 0 }),
            type: 'walletClient',
        }),
        account: account ? (0, parseAccount_js_1.parseAccount)(account) : undefined,
    };
    return {
        ...client,
        ...(0, wallet_js_1.walletActions)(client),
    };
}
exports.createWalletClient = createWalletClient;
//# sourceMappingURL=createWalletClient.js.map